import { Fill, Stroke, Style, Circle as CircleStyle } from 'ol/style';

export const drawFeaturesStyles = new Style({
  fill: new Fill({
    color: 'rgb(43, 108, 176, 0.4)',
  }),
  stroke: new Stroke({
    lineDash: [4],
    color: '#2B6CB0',
    width: 2,
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: '#2B6CB0',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgb(43, 108, 176, 0.4)',
    }),
  }),
})
